/* eslint-disable max-len */
import React from "react";
import { useModal } from "../../../context/ModalContext";
import { CloseIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import GvSecondaryButton from "../../../components/GvSecondaryButton/GvSecondaryButton";
import { useNavigate } from "react-router-dom";
import { modalStorageKeys } from "../../../config/params";
import { formatPetNames } from "../../../components/AvailableTimeSlots/ExpressAvailableTimeSlots";
import { markPetsShownForModal } from "../../../services/wellness-plans-by-user/wellness-plan-by-user.service";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { useCombinedAlertsDataStore } from "../../../hooks";
import WellnessRenewalPetAvatars from "../../../components/PetAvatars/WellnessRenewalPetAvatars";


const WellnessPlanRenewUnsuccessfulAlert = () => {
  const { closeModal } = useModal();
  const { failedRenewalsWPData } = useCombinedAlertsDataStore();
  const navigate = useNavigate();

  const handlePrimaryCta = () =>{
    if (failedRenewalsWPData.length === 1) {
      userActivityLogger(MIXPANEL_EVENTS.PAY_NOW_CLICKED,
        {
          pet_name: failedRenewalsWPData[0].petName,
          referred_from_page: "pending_overdue_invoice",
          due_amount: `${failedRenewalsWPData[0].pendingSquareInvoices[0].amount}`,
          invoice_due_date: failedRenewalsWPData[0].pendingSquareInvoices[0].dueDate,
        });
      window.open(failedRenewalsWPData[0]?.pendingSquareInvoices[0]?.publicUrl);
    } else {
      navigate("/user-profile/payment");
      //  multiple pets pay now clicked
      failedRenewalsWPData.forEach((petData) => {
        userActivityLogger(MIXPANEL_EVENTS.PAY_NOW_CLICKED,
          {
            pet_name: petData.petName,
            referred_from_page: "pending_overdue_invoice",
            due_amount: `${petData.pendingSquareInvoices[0].amount}`,
            invoice_due_date: petData.pendingSquareInvoices[0].dueDate,
          });
      });
    }
    handleModalClose();
  };

  const handleModalClose = (closeFromParent?: "closeIcon" | "gotIt") =>{
    if (failedRenewalsWPData.length) {
      markPetsShownForModal(modalStorageKeys.autoRenewEndedPlans, failedRenewalsWPData.map((petData)=>petData.petId));
    }
    if (closeFromParent === "closeIcon") {
      failedRenewalsWPData.forEach((petData) => {
        userActivityLogger(MIXPANEL_EVENTS.RENEWAL_UNSUCCESSFUL_POP_UP_DISMISSED, {
          pet_name: petData.petName,
          plan_name: petData.wellnessPlanName,
        });
      });
    } else if (closeFromParent === "gotIt") {
      failedRenewalsWPData.forEach((petData) => {
        userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_GOT_IT_IN_POPUP, {
          popup_type: "plan_renewal_unsuccessful",
          renewal_flag: "yes",
          plan_name: petData.wellnessPlanName,
          pet_name: petData.petName,
        });
      });
    }
    closeModal();
  };


  return (
    <>

      {failedRenewalsWPData.length > 0 &&
      <div className="flex flex-col justify-between w-full h-full xl:w-[25rem]">
        <div className="flex justify-end">
          <CloseIcon
            onClick={()=>handleModalClose("closeIcon")}
            className="text-light-black cursor-pointer"
          />
        </div>
        <div className="w-full flex flex-col justify-between items-center">
          {failedRenewalsWPData.length &&
            <div>
              <WellnessRenewalPetAvatars petDetails={failedRenewalsWPData} defaultOverdueStatus={true} />
            </div>
          }
          <div className="text-xl font-semibold flex justify-center xl:w-80 text-center">
            GoodPet+ Plan Renewal Unsuccessful
          </div>
        </div>

        <div className="text-center pt-3 pb-4">
          {`${formatPetNames(failedRenewalsWPData.map((petData)=>petData.petName ))} Wellness Plan was not renewed due to an unpaid balance.
          To continue booking appointments  please pay the outstanding invoice.`}
        </div>

        <div className="pt-2 w-full">
          <StyledBookingFlowButton
            disabled={false}
            fullWidth
            color="primary"
            className={"!w-full !font-semibold !border-1 !border-gray-4 hover:!text-white hover:!bg-black !h-[2.5rem] !text-sm" }
            size="small"
            onClick={handlePrimaryCta}
          >
            {"Pay Now"}
          </StyledBookingFlowButton>
          <div className="w-full">
            <GvSecondaryButton
              type="button"
              onClick={() => handleModalClose("gotIt")}
              className="!w-full !font-semibold !border-1 !border-gray-4 hover:!bg-gray-3 !h-[2.5rem] !text-sm"
            >
              {"Got It"}
            </GvSecondaryButton>
          </div>
        </div>
      </div>}
    </>
  );
};

export default WellnessPlanRenewUnsuccessfulAlert;
